import React, { useState } from 'react'

const Calculator = (props) => {

    let totalG = props.totalG;
    const [rate, setRate] = useState('13.8');
    const [amount, setAmount] = useState('16000');
    const [years, setYears] = useState('2');

    const calculate = (e) => {
        e.preventDefault();
        // console.log("Button..")
        //rate = ;
        totalG((((Number)(amount * years * ((rate / 100)+1)))).toFixed(1));
    };

  return (
    <div>
        <h1>Mortgage calculator</h1>
      <form className='form' onSubmit={(e)=>{calculate(e)}}>
        <div className='row g-3  align-items-center calculate'>
            <div className='col-4 align-right'>
                <label className='col-form-label'>Amount:</label>  
            </div>

            <div className='col-4' aria-describedby='amountHelpLine'>
                <input className='form-control' value={amount} type="number" onChange={(e)=>setAmount(e.target.value)}/>
            </div>
            <div className="col-4">
                <span id="amountHelpLine" className="form-text">
                    You must enter your total amount of credit
                </span>
            </div>
        </div>


        <div className='row g-3  align-items-center calculate'>
            <div className='col-4 align-right'>
                <label className='col-form-label'>Years:</label>  
            </div>

            <div className='col-4' aria-describedby='yearsHelpLine'>
                <input className='form-control'  value={years} type="text" onChange={(e)=>setYears(e.target.value)}/>
            </div>
            <div className="col-4">
                <span id="yearsHelpLine" className="form-text">
                    You must enter the number of years
                </span>
            </div>
        </div>

        <div className='row g-3  align-items-center calculate'>
            <div className='col-4 align-right'>
                <label className='col-form-label'>Rate:</label>  
            </div>

            <div className='col-4' aria-describedby='rateHelpLine'>
                <input className='form-control'  value={rate} type="text" onChange={(e)=>setRate(e.target.value)}/> 
            </div>
            <div className="col-4">
                <span id="rateHelpLine" className="form-text">
                    Your rate must be in percentage % Ex. 18 %
                </span>
            </div>
        </div>

        <div className='row g-3  align-items-center calculate'>
            <button className='btn btn-primary' onClick={(e)=>{calculate(e)}}>Calculate!</button>
        </div>
      </form>

    </div>
  )
}

export default Calculator